import React from "react";
import {
  MapContainer,
  TileLayer,
  Marker,
  Popup,
  Polyline,
  ScaleControl,
} from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import "./style.scss";
import { LayersControl } from "react-leaflet";
import { IDaySale } from "../../interfaces/daysales.interface";
import { Link } from "react-router-dom";
const { BaseLayer } = LayersControl;
// Fix for missing marker icons
delete (L.Icon.Default.prototype as any)._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl:
    "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png",
  iconUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png",
  shadowUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png",
});
const firstIcon = new L.Icon({
  iconUrl:
    "https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-red.png",
  shadowUrl:
    "https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-shadow.png",
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41],
});

const lastIcon = new L.Icon({
  iconUrl:
    "https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-green.png",
  shadowUrl:
    "https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-shadow.png",
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41],
});

const shopIcon = new L.Icon({
  iconUrl:
    "https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-yellow.png",
  shadowUrl:
    "https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-shadow.png",
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41],
});

type Coordinate = {
  latitude: number;
  longitude: number;
  _id?: string;
};

interface Props {
  coordinates: Coordinate[];
  sales: IDaySale[];
}

const CustomMapContainer = ({ coordinates, sales }: Props) => {
  const center: [number, number] = [
    coordinates[0].latitude,
    coordinates[0].longitude,
  ];

  const polylinePositions: [number, number][] = coordinates.map((coord) => [
    coord.latitude,
    coord.longitude,
  ]);

  return (
    <div className="h-100 w-100">
      <div className="d-flex my-2 align-items-center gap-2">
        <span className="bg-danger p-2 points-mark"></span>
        <span>Trip Starting Point</span>
        <span className="bg-success p-2 points-mark"></span>{" "}
        <span> Trip Ending Point</span>
        <span className="bg-primary p-2 points-mark"></span>{" "}
        <span> Trip Points</span>
        <span className="bg-warning p-2 points-mark"></span>{" "}
        <span> Shop</span>
      </div>
      <MapContainer
        center={center}
        zoom={24}
        scrollWheelZoom
        className="map-container-layout"
      >
        <LayersControl position="topright">
          <BaseLayer checked name="Street">
            <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
          </BaseLayer>
          <BaseLayer name="Satellite">
            <TileLayer url="https://{s}.tile.opentopomap.org/{z}/{x}/{y}.png" />
          </BaseLayer>
        </LayersControl>
        <TileLayer
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          attribution='&copy; <a target="blank" href="https://drinkgroovy.com">Drinkgroovy</a>'
        />
        {coordinates.map((coord, index) => (
          <Marker
            key={coord?._id}
            position={[coord.latitude, coord.longitude]}
            icon={
              index === 0
                ? firstIcon
                : index === coordinates.length - 1
                ? lastIcon
                : new L.Icon.Default()
            }
          >
            <Popup>
              <div>
                <p>
                  <strong>ID:</strong> {coord._id}
                </p>
                <p>
                  <strong>Lat:</strong> {coord.latitude}
                </p>
                <p>
                  <strong>Lng:</strong> {coord.longitude}
                </p>
              </div>
            </Popup>
          </Marker>
        ))}

        {sales.map((sale) => (
          <Marker
            key={sale?._id}
            position={[
              Number(sale?.location?.latitude),
              Number( sale?.location?.longitude ),
            ]}
            icon={shopIcon}
          >
            <Popup>
              <div>
                <p>
                  <strong>Shop Name:</strong>{" "}
                  {typeof sale?.shop !== "string" ? sale?.shop?.shopName : ""}
                </p>
                <p>
                  <strong>Shop Owner:</strong>{" "}
                  {typeof sale?.shop !== "string" ? sale?.shop?.shopOwner : ""}
                </p>
                <p>
                  <strong>Shop Contact Number:</strong>{" "}
                  {typeof sale?.shop !== "string"
                    ? sale?.shop?.shopContactNumber
                    : ""}
                </p>
                <p>
                  <strong>Address:</strong>
                  <span className="fs-7">
                    {" "}
                    {typeof sale?.shop !== "string"
                      ? sale?.shop?.shopAddress
                      : ""}
                    ,{" "}
                    {typeof sale?.shop !== "string" ? sale?.shop?.shopCity : ""}
                    ,{" "}
                    {typeof sale?.shop !== "string"
                      ? sale?.shop?.shopState
                      : ""}
                  </span>
                </p>
                <Link
                  to={`/shops/${
                    typeof sale?.shop !== "string" ? sale?.shop?._id : ""
                  }`}
                  target="blank"
                >
                  View Shop
                </Link>
              </div>
            </Popup>
          </Marker>
        ))}

        <Polyline positions={polylinePositions} color="blue" />
        <ScaleControl position="bottomleft" />
      </MapContainer>
    </div>
  );
};

export default CustomMapContainer;
